export const getRefId = value => {
	if (!value) return null
	if (typeof value === 'object') return value?._id || value?.id || null
	return value
}

export const getRefLabel = (value, fallback = '-') => {
	if (!value) return fallback
	if (typeof value === 'object') return value?.nazwa || fallback
	return fallback
}

export const resolveRef = (...values) => {
	for (const value of values) {
		const id = getRefId(value)
		if (id) return { id, label: getRefLabel(value) }
	}
	return { id: null, label: '-' }
}

export default function FilterableCell({ id, label, onFilter }) {
	if (!id) return label

	return (
		<button
			type="button"
			onClick={() => onFilter(id)}
			className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
			{label}
		</button>
	)
}
